/* QubikoTech: cambia solo textos visibles del embed publicado Klaviyo.
   Los envíos siguen gestionados por Klaviyo. */
(() => {
  const target='.qt-landing .klaviyo-form-TNPpqt';
  const wantedButton='Quiero recibir la guía gratis';
  const wrongSuccess=/YA TIENES TU PRIMER RECURSO GRATUITO|YA TIENES TU PRIMER RECURSO|REVISAR TU BANDEJA DE ENTRADA/i;
  function replaceText(root) {
    const nodes=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode=nodes.nextNode())) {
      const text=textNode.nodeValue || '';
      const trim=text.trim();
      if (/^¡?La quiero!?$/i.test(trim)) {
        textNode.nodeValue=text.replace(trim,wantedButton);
      } else if(wrongSuccess.test(trim)) {
        textNode.nodeValue='¡Gracias por unirte a QubikoTech! Te enviaremos la guía cuando esté lista y te avisaremos del lanzamiento.';
      }
    }
  }
  function enhance(root) {
    for (const field of root.querySelectorAll('input[type="email"]')) {
      if(field.placeholder!=='tu@email.com')field.placeholder='tu@email.com';
      if(!field.getAttribute('aria-label'))field.setAttribute('aria-label','Tu correo electrónico');
    }
    replaceText(root);
  }
  function start(scope) {
    scope.querySelectorAll(target).forEach(root=>{
      if(root.dataset.qtCopyReady==='true')return;
      root.dataset.qtCopyReady='true';
      enhance(root);
      let queued=false;
      const obs=new MutationObserver(()=>{
        if(queued)return;
        queued=true;
        queueMicrotask(()=>{queued=false;if(root.isConnected)enhance(root);else obs.disconnect();});
      });
      obs.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['placeholder']});
      document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root))obs.disconnect()},{once:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(document),{once:true});
  else start(document);
  document.addEventListener('shopify:section:load',e=>start(e.target));
})();
